import { graphqlPost } from "api/graphqlClient";
import { Callout } from "components/Form/components/Callout/Callout";
import { cancelButtonProps } from "components/Form/components/CancelButton/CancelButton";
import { getDefaultRequiredValue } from "components/Form/components/SchemaForm/SchemaFormService";
import { showConfirmModal } from "components/Modal/showConfirmModal";
import RestErrorNotification from "components/Notification/RestErrorNotification";
import { valueAndSchema } from "containers/Resources/screens/ResourcesSingle/constants";
import { FormApi } from "final-form";
import { useRef } from "react";
import { OnChange } from "react-final-form-listeners";

export const setNewSchemaValues = (schedulerId, changeSchemaFormValuesMutator) => {
    if (schedulerId === null) {
        changeSchemaFormValuesMutator({ values: null, schema: {} });
    } else {
        const params = {
            query: `query ($id: String!) {
                             scheduler(id: $id) {
                                 configuration_schema
                             }
                         }`,
            variables: {
                id: schedulerId,
            },
        };

        graphqlPost(params)
            .then((data: any) => {
                const schema = data?.data?.scheduler.configuration_schema ?? {};
                const defaultValues = getDefaultRequiredValue(schema, schema, null);
                changeSchemaFormValuesMutator({
                    values: defaultValues,
                    schema: schema,
                });
            })
            .catch((error) => {
                <RestErrorNotification
                    titleOverride="There was a problem fetching scheduler configuration schema"
                    error={error}
                />;
            });
    }
};

export const OnChangeSchedulerId = ({ form }: { form: FormApi }) => {
    /**to avoid looping when setting scheduler_id to null */
    const suppressOnChange = useRef(false);

    const showScheduleWarning = (newSchedulerId, prevSchedulerId) =>
        showConfirmModal({
            content: (
                <div className="dirtyFormWarning">
                    <Callout
                        text={
                            <div className="warningContent">
                                Changing the scheduler will reset the configuration of the schedule
                            </div>
                        }
                        type={"warning"}
                        className="rootCallout"
                    />
                </div>
            ),
            onConfirm: () => {
                setNewSchemaValues(newSchedulerId, form.mutators.changeSchemaFormValues);
            },
            onCancel: () => {
                suppressOnChange.current = true;
                form.mutators.changeScheduler(prevSchedulerId);
            },
            cancelButtonProps: cancelButtonProps,
            confirmButtonProps: { className: "button button--primary-blue" },
            className: "confirmationModal",
            centered: true,
        });

    return (
        <OnChange name="scheduler_id">
            {(value, prevValue) => {
                if (suppressOnChange.current) {
                    suppressOnChange.current = false;
                    return;
                }
                if (form.getState()?.values?.[valueAndSchema]?.values != null && prevValue !== "") {
                    showScheduleWarning(value, prevValue);
                } else {
                    setNewSchemaValues(value, form.mutators.changeSchemaFormValues);
                }
            }}
        </OnChange>
    );
};
